// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"_3Mopft","fullWidth":"_2oay3x"};